import { objectWithoutPropertiesLoose as _objectWithoutPropertiesLoose, extends as _extends } from '../../../_virtual/_rollupPluginBabelHelpers.js';
import React__default from 'react';
import { __DEV__ } from '../../../utils/assertion.esm.js';
import '../../../utils/ssr.esm.js';
import '../../../utils/number.esm.js';
import '../../../utils/array.esm.js';
import '../../../utils/breakpoint.esm.js';
import '../../../utils/context.esm.js';
import '../../../utils/dom.esm.js';
import '../../../utils/tabbable.esm.js';
import '../../../utils/dom-query.esm.js';
import '../../../utils/logger.esm.js';
import '../../../utils/focus.esm.js';
import '../../../utils/function.esm.js';
import '../../../utils/keydown.esm.js';
import '../../../utils/lazy.esm.js';
import '../../../utils/object.esm.js';
import '../../../utils/react-helpers.esm.js';
import '../../../utils/style-props.esm.js';
import '../../../utils/tailwind.esm.js';
import Box from '../../Box/index.esm.js';
import Card from '../../Card/index.esm.js';
import Transition from '../../Transition/index.esm.js';
import { usePopoverContext } from '../context.esm.js';

var PopoverContent = /*#__PURE__*/React__default.forwardRef(function (props, ref) {
  var children = props.children,
      rest = _objectWithoutPropertiesLoose(props, ["children"]);

  var _usePopoverContext = usePopoverContext(),
      getPopoverProps = _usePopoverContext.getPopoverProps,
      getPopoverPositionerProps = _usePopoverContext.getPopoverPositionerProps,
      open = _usePopoverContext.open;

  var _getPopoverProps = getPopoverProps(),
      popoverProps = _objectWithoutPropertiesLoose(_getPopoverProps, ["translate"]);

  var _getPopoverPositioner = getPopoverPositionerProps({}, ref),
      popoverPositionerProps = _objectWithoutPropertiesLoose(_getPopoverPositioner, ["translate"]);

  return React__default.createElement(Box, _extends({
    zIndex: "z-20",
    outline: "outline-none",
    minWidth: "min-w-max-content"
  }, popoverPositionerProps), React__default.createElement(Transition, {
    show: open,
    enter: ['ease-out', 'duration-150'],
    enterFrom: ['opacity-0', 'scale-95'],
    enterTo: ['opacity-100', 'scale-100'],
    leave: ['ease-in', 'duration-100'],
    leaveFrom: ['opacity-100', 'scale-100'],
    leaveTo: ['opacity-0', 'scale-95']
  }, React__default.createElement(Card, _extends({
    transform: "transform",
    borderRadius: "rounded-lg",
    borderWidth: "border-0",
    boxShadow: "shadow-menu",
    position: "relative",
    display: "flex",
    flexDirection: "flex-col",
    width: "w-80"
  }, popoverProps, rest), children)));
});

if (__DEV__) {
  PopoverContent.displayName = 'PopoverContent';
}

export default PopoverContent;
//# sourceMappingURL=index.esm.js.map
